import { render, staticRenderFns } from "./editAppFun.vue?vue&type=template&id=70882de8"
import script from "./editAppFun.vue?vue&type=script&lang=js"
export * from "./editAppFun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports